



































import { Component, Prop, Vue } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import { DataModules } from "@/store/modules/data";

@Component
export default class UpmindRemoteAccessSummaryMsg extends Vue {
  // Props

  @Prop({ required: true })
  public readonly client!: IClient;

  // Data

  public isProcessing = false;

  // Computed

  public get showMessage() {
    return (
      this.$store.getters["isAuthenticatedAdminContext"] &&
      this.$store.getters["isUpmindContext"]
    );
  }

  public get canImpersonateOrg(): boolean {
    return this.$store.getters[`data/${DataModules.CLIENTS}/canImpersonateOrg`](
      this.client
    );
  }

  public get hasOrgImpersonationEnabled(): boolean {
    return !!this.client?.upmind_org?.upmind_impersonation_enabled;
  }

  public get orgName() {
    return this.client?.upmind_org?.name;
  }

  public get relativeExpiryDate() {
    const expiry = this.client?.upmind_org?.upmind_impersonation_expiry;
    if (!expiry) return null;
    return this.$moment
      .utc(expiry)
      .local()
      .from(this.$moment.now());
  }

  // Methods

  public async impersonateOrg() {
    if (!this.canImpersonateOrg) return Promise.resolve();
    try {
      this.isProcessing = true;
      await this.$store.dispatch("auth/admin/impersonateUser", {
        orgId: this.client.upmind_org?.id,
        userId: this.client.upmind_org_user_id
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
